import axios from "axios";
import { getCachedToken } from "./services/deviceAgent";

// const API_URL = process.env.REACT_APP_API_URL || "http://localhost:8080/api";
export const API_URL = process.env.REACT_APP_API_URL || "http://192.168.0.21:8085/TMS/api";
//const API_URL = "http://localhost:8085/TMS/api";

console.log("API URL:", API_URL);

// WSPulse device verification: attach the signed agent token (if present) to
// every API request. This only ADDS headers; it never throws or blocks the
// request so the backend remains the source of truth for enforcement.
axios.interceptors.request.use((config) => {
  const t = getCachedToken();
  if (t) {
    config.headers = config.headers || {};
    config.headers["X-WS-MAC"] = t.mac;
    config.headers["X-WS-TS"] = String(t.ts);
    config.headers["X-WS-SIG"] = t.sig;
  }
  // Attach the HRMS token so the backend can grant the role-based device
  // exception (e.g. CEO/CTO bypass MAC verification). Read directly from
  // sessionStorage to avoid a circular import with services/sso.
  try {
    const hrms = sessionStorage.getItem("hrmsToken");
    if (hrms) {
      config.headers = config.headers || {};
      config.headers["X-HRMS-AUTH"] = hrms;
    }
  } catch { /* ignore */ }
  return config;
});

export const createAccount = async (data) => {
  try {
    const response = await axios.post(`${API_URL}/signup`, data);
    return response.data;
  } catch (error) {
    console.error("Error creating account:", error);
    throw error;
  }
};

export const login = async (credentials) => {
  try {
    const response = await axios.post(`${API_URL}/auth/hrms-login`, credentials);
    return response.data;
  } catch (error) {
    console.error("Error logging in:", error);
    throw error;
  }
};




export const sendOtp = async (trngId) => {
  try {
    const response = await axios.post(`${API_URL}/users/send-otp`, { trngId });
    return response.data;
  } catch (error) {
    console.error("Error sending OTP:", error);
    throw error;
  }
};

export const resetPassword = async (data) => {
  try {
    const response = await axios.post(`${API_URL}/users/verify-otp`, data);
    return response.data;
  } catch (error) {
    console.error("Error resetting password:", error);
    throw error;
  }
};

export const storeUserDetails = async () => {
  const data = [
    {
      "userid": "2019WS10018",
      "trngid": "WS10018",
      "password": "Test@123",
      "username": "Britto",
      "firstname": "Brit",
      "lastname": "A",
      "emailid": "abs@gmail.bom",
      "phonenumber": "02345678444",
      "roleId": "R005",
    }
  ]
  try {
    const response = await axios.post(`${API_URL}/users/bulk-create`, data);
    // return response.data;
  } catch (error) {
    console.error("Error storing user details:", error);
    throw error;
  }
};


// const data = [
//   {
//     "userid": "2019Ws10019",
//     "trngid": "Ws10111",
//     "password": "$2a$10$uuitzF5IfvDByIhsOE5TieovEOJ6LyJJppMgaBjbECZBAaeLj0NnK",
//     "username": "BB",
//     "firstname": "BB",
//     "lastname": "A",
//     "emailid": "abs@gmail.bom",
//     "phonenumber": "9787255965",
//     "roleId": "R001",

//   },
//   {
//     "userid": "2019wss123",
//     "trngid": "wss123",
//     "password": "$2a$10$2Z3nNVR5uGKJE33jSK9yreGFDwvktrzFuWwLb95IpQhex5eLOAk8e",
//     "username": "wss123",
//     "firstname": "BBB",
//     "lastname": "A",
//     "emailid": "wwm@gmail.com",
//     "phonenumber": "987635616",
//     "roleId": "R001",
//   },
//   {
//     "userid": "2019WS1155",
//     "trngid": "WS1155",
//     "password": "$2a$10$G7szEGln2OiGaqVA0SnUpu0mN7EeaS3JpLpC83OSD35sYSholZL3C",
//     "username": null,
//     "firstname": "Aswathi",
//     "lastname": null,
//     "emailid": "aswathi.ravindran@whitestones.co.in",
//     "phonenumber": "09787255964",
//     "roleId": "R001",
//   },
//   {
//     "userid": "2019WS1122",
//     "trngid": "WS1122",
//     "password": "$2a$10$VVz9JDazDVsGjfj3L5AzYeWPs1LCvU/HT6kcqUr55TRHVGJguIzGa",
//     "username": "Arunmaran",
//     "firstname": "Arunmaran",
//     "lastname": "Murugasen",
//     "emailid": "arunmaran.murugesan@whitestones.co.in",
//     "phonenumber": "9345287327",
//     "roleId": "R001",
//   },
//   {
//     "userid": "2019WS10018",
//     "trngid": "WS10018",
//     "password": "$2a$10$qECY9SHPCdM1cA16TuC9.eDKw7GrlLOCEoE27iJuP9HlAEYFftVOm",
//     "username": "Britto",
//     "firstname": "Brit",
//     "lastname": "A",
//     "emailid": "abs@gmail.bom",
//     "phonenumber": "02345678444",
//     "roleId": "R001",
//   },
//   {
//     "userid": "2019WS10009",
//     "trngid": "WS10009",
//     "password": "$2a$10$dCrmV.cSDhplIYnAvyNUR.XNiUn9d/pmW87uGj3AT79BN6dur8bum",
//     "username": "ANBU",
//     "firstname": "ANBU",
//     "lastname": "S",
//     "emailid": "anbarasan.sekar@whitestones.in",
//     "phonenumber": "9788313457",
//     "roleId": "R001",
//   }
// ]
// // const alreadyCreated = localStorage.getItem("bulkUsersCreated");

// // if (!alreadyCreated) {
// // console.log("ecekfoks")
// //   const res = await storeUserDetails(data);
// //   console.log("ahd"+res)
// //   localStorage.setItem("bulkUsersCreated", "true");
// // }
// export const storeDetails = async () =>{}


export const fetchAllActiveTrainees = async () => {
  try {
    const response = await axios.get(`${API_URL}/users/all-trainees`);
    return response.data;
  } catch (error) {
    console.error("Error fetching all active trainees:", error);
    throw error;
  }
};

export const fetchAllTrainees = async () => {
  try {
    const response = await axios.get(`${API_URL}/users/all`);
    return response.data;
  } catch (error) {
    console.error("Error fetching trainees:", error);
    throw error;
  }
};


export const createAssessment = async (empId, data) => {
  try {
    const response = await axios.post(`${API_URL}/assessments/create/${empId}`, data);
    return response.data;
  } catch (error) {
    console.error("Error creating assessment:", error);
    throw error;
  }
};

export const updateAssessment = async (assessmentId, data) => {
  try {
    const response = await axios.put(
      `${API_URL}/assessments/update/${assessmentId}`,
      data
    );
    return response.data;
  } catch (error) {
    console.error("Error updating assessment:", error);
    throw error;
  }
};

export const fetchAllAssessments = async () => {
  try {
    const response = await axios.get(`${API_URL}/assessments/all`);
    return response.data;
  } catch (error) {
    console.error("Error fetching assessments:", error);
    throw error;
  }
};




export const fetchAssessmentsByTrainee = async (empId) => {
  try {
    const response = await axios.get(`${API_URL}/assessments/trainee/${empId}`);
    return response.data;
  } catch (error) {
    console.error("Error fetching assessments for trainee:", error);
    throw error;
  }
};



export const fetchAllTraineeSummary = async () => {
  try {
    const response = await axios.get(`${API_URL}/users/summary`);
    return response.data;
  } catch (error) {
    console.error("Error fetching trainee summary:", error);
    throw error;
  }
};

export const fetchAllTraineeSummaryAdmin = async () => {
  try {
    const response = await axios.get(`${API_URL}/users/all-trainee/summary`);
    return response.data;
  } catch (error) {
    console.error("Error fetching trainee summary:", error);
    throw error;
  }
}


// export const getAllTrainers = async () => {
//   try {
//     const res = await axios.get(`${API_URL}/trainers/all`);
//     return res.data;
//   } catch (error) {
//     console.error("Error fetching trainers:", error);
//     throw error;
//   }
// };


export const getAllTrainers = async () => {
  try {
    const res = await axios.get(`${API_URL}/users/manager/all`);
    console.log("Trainers fetched:", res.data);
    return res.data;
  } catch (error) {
    console.error("Error fetching trainers:", error);
    throw error;
  }
};



// export const addTrainer = async (data) => {
//   try {
//     const res = await axios.post(`${API_URL}/trainers/add`, data);
//     return res.data;
//   } catch (error) {
//     console.error("Error adding trainer:", error);
//     throw error;
//   }
// };

export const createSchedule = async (trainerId, data) => {
  try {
    const res = await axios.post(`${API_URL}/schedule/create/${trainerId}`, data);
    return res.data;
  } catch (error) {
    console.error("Error creating schedule:", error);
    throw error;
  }
};

export const assignTrainees = async (scheduleId, traineeList) => {
  try {
    const res = await axios.post(`${API_URL}/schedule/assign/${scheduleId}`, traineeList);
    return res.data;
  } catch (error) {
    console.error("Error assigning trainees:", error);
    throw error;
  }
};

export const getAllSchedules = async () => {
  try {
    const res = await axios.get(`${API_URL}/schedule/all`);
    return res.data;
  } catch (error) {
    console.error("Error fetching schedules:", error);
    throw error;
  }
};

export const uploadSyllabusAPI = async (formData) => {
  // const res = await axios.post(`${API_URL}/syllabus/add`, formData);
  const res = await axios.post(`${API_URL}/syllabus/add`, formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return res;
};

export const getAllSyllabusAPI = async () => {
  const res = await axios.get(`${API_URL}/syllabus/all`);
  return res;
};

export const updateSyllabusAPI = async (id, formData) => {
  const res = await axios.put(`${API_URL}/syllabus/update/${id}`, formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return res;
};



export const fetchAllSchedules = async () => {
  try {
    const response = await axios.get(`${API_URL}/schedule/all`);
    return response.data;
  } catch (error) {
    console.error("Error fetching schedules:", error);
    throw error;
  }
};


export const getSyllabusByIdAPI = async (id) => {
  //return await axios.get(`${API_URL}/syllabus/` + id);
  try {
    const response = axios.get(`${API_URL}/syllabus/` + id);
    return response.data;
  } catch (error) {
    console.error("Error fetching schedules:", error);
    throw error;
  }
};





// export const updateStepProgress = async (empId, stepId, progress) => {
//   const payload = { empId, stepId, progress };
//   const response = await fetch("http://localhost:8080/api/progress/update-step", {
//     method: "POST",
//     headers: { "Content-Type": "application/json" },
//     body: JSON.stringify(payload),
//   });

//   if (!response.ok) throw new Error("Failed to update step progress");
//   return await response.json(); // contains overallProgress
// };


// export const fetchSteps = async (empId) => {
//   const res = await axios.get(`${API_URL}/steps/${empId}`);
//   return res.data;
// };

export const updateStepProgress = async (empId, stepId, progress, durationTime) => {
  const res = await axios.post(`${API_URL}/progress/update-step`, {
    empId,
    stepId,
    progress,
    durationTime
  });
  return res.data;
};

export const getOverallProgressTime = async (empId) => {
  const response = await axios.get(`${API_URL}/progress/overall-time?empId=${empId}`);
  return response.data.overallTimeSeconds;
};


export const fetchUserByEmpId = async (empId) => {
  try {
    const res = await axios.get(`${API_URL}/users/${empId}`);

    // API response format:
    // { status: 200, success: true, message: "...", data: {...user} }

    return res.data.data; // return actual user object
  } catch (error) {
    console.error("Error fetching user by empId:", error);
    throw error;
  }
};

// export const fetchInterviewScheduleByEmpId = async (empId) => {
//   try {
//     const res = await axios.get(`${API_URL}/schedule/user/${empId}`);
//     return res.data; // return list of interviews
//   } catch (error) {
//     console.error("Error fetching interview schedule:", error);
//     throw error;
//   }
// };

export const fetchInterviewScheduleByEmpId = async (empId) => {

  try {
    const response = await axios.get(`${API_URL}/schedule/user-interview/${empId}`);

    // Pure accurate data return karenge
    return response.data;
  } catch (error) {
    console.error("Error fetching schedules:", error);
    throw error;
  }
};

export const fetchStepByEmpId = async (empId) => {
  try {
    const response = await axios.get(
      `${API_URL}/step-progress/emp/${empId}`
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching schedules:", error);
    throw error;
  }
};


export const startSubTopic = async (formData) => {
  try {
    const response = await axios.post(`${API_URL}/step-progress/start`, formData);
    return response.data;
  } catch (error) {
    console.error("Error starting subtopic:", error);
    throw error;
  }
}


export const completeSubTopic = async (formData) => {
  try {
    const response = await axios.post(`${API_URL}/step-progress/complete`, formData);
    return response.data;
  } catch (error) {
    console.error("Error completing subtopic:", error);
    throw error;
  }
}

export const fetchCompletedSubTopics = async () => {
  try {
    const response = await axios.get(`${API_URL}/syllabus/all-progress`);
    return response;
  } catch (error) {
    console.error("Error fetching completed subtopics:", error);
    throw error;
  }
}


// export const approveSubTopicAPI = async (progressId) => {
//   try {
//     const response = await fetch(
//       `${API_URL}/step-progress/approve/${progressId}`,
//       {
//         method: "PUT",
//         headers: {
//           "Content-Type": "application/json",
//         },
//       }
//     );

//     if (!response.ok) {
//       throw new Error("Failed to approve subtopic");
//     }

//     return await response.json();
//   } catch (error) {
//     console.error("Approve API error:", error);
//     throw error;
//   }
// };

export const approveSubTopicAPI = async (progressId, review = "") => {
  const url = review
    ? `${API_URL}/step-progress/approve/${progressId}?review=${encodeURIComponent(review)}`
    : `${API_URL}/step-progress/approve/${progressId}`;

  const response = await fetch(url, { method: "PUT" });

  if (!response.ok) {
    throw new Error("Failed to approve subtopic");
  }

  return response.json();
};


// export const rejectSubTopicAPI = async (progressId, review) => {
//   try {
//     const response = await fetch(
//       `${API_URL}/step-progress/reject/${progressId}?review=${encodeURIComponent(review)}`,
//       {
//         method: "PUT",
//         headers: {
//           "Content-Type": "application/json",
//         },
//       }
//     );

//     if (!response.ok) {
//       throw new Error("Failed to reject subtopic");
//     }

//     return await response.json();
//   } catch (error) {
//     console.error("Reject API error:", error);
//     throw error;
//   }
// };

export const rejectSubTopicAPI = async (progressId, review) => {
  if (!review || review.trim() === "") {
    throw new Error("Review is required for rejection");
  }

  const response = await fetch(
    `${API_URL}/step-progress/reject/${progressId}?review=${encodeURIComponent(review)}`,
    { method: "PUT" }
  );

  if (!response.ok) {
    throw new Error("Failed to reject subtopic");
  }

  return response.json();
};


export const fetchSyllabusProgressByEmpId = async (empid) => {
  try {
    const response = await axios.get(
      `${API_URL}/syllabus/all-progress/${empid}`
    );
    return response;
  } catch (error) {
    console.error("Error fetching syllabus progress by empid:", error);
    throw error;
  }
};


// export const fetchSyllabusProgressByEmpId = async (empid) => {
//   try {
//     const response = await axios.get(
//       `${API_URL}/syllabus/user/${empid}`
//     );
//     return response;
//   } catch (error) {
//     console.error("Error fetching syllabus progress by empid:", error);
//     throw error;
//   }
// };





const fetchSyllabusProgress = async (empId) => {
  const res = await fetch(
    `${API_URL}/syllabus/all-progress/${empId}`
  );

  if (!res.ok) {
    const text = await res.text();
    console.error("Backend error:", text);
    throw new Error("Failed to fetch syllabus progress");
  }

  return await res.json(); // ✅ guaranteed JSON
};


export const fetchTraineeById = async (traineeId) => {
  const res = await fetch(
    `${API_URL}/assessments/trainee/${traineeId}`
  );

  if (!res.ok) {
    const text = await res.text();
    console.error("Backend error:", text);
    throw new Error("Failed to fetch trainee details");
  }

  return await res.json(); // ✅ guaranteed JSON
};



export const updateInterviewSchedule = async (scheduleId, data) => {
  try {
    const res = await axios.put(`${API_URL}/schedule/update/${scheduleId}`, data);
    return res.data;
  } catch (error) {
    console.error("Error updating schedule:", error);
    throw error;
  }
};

export const deleteInterviewSchedule = async (scheduleId) => {
  try {
    const res = await axios.delete(`${API_URL}/schedule/delete/${scheduleId}`);
    return res.data;
  } catch (error) {
    console.error("Error deleting schedule:", error);
    throw error;
  }
};

export const fetchTraineesByManagerId = async (managerId) => {
  try {
    const response = await axios.get(
      `${API_URL}/users/manager/${managerId}`
    );
    return response.data; // Returns ApiResponse object
  } catch (error) {
    console.error("Error fetching trainees by manager:", error);
    throw error;
  }
};

// 2. Get Trainee Summary for a Manager
export const fetchTraineeSummaryByManager = async (managerUserId) => {
  try {
    const response = await axios.get(
      `${API_URL}/users/${managerUserId}/trainee-summary`
    );
    return response.data; // Returns ApiResponse object
  } catch (error) {
    console.error("Error fetching trainee summary:", error);
    throw error;
  }
};


export const deleteSubTopicAPI = async (subTopicId) => {
  return axios.delete(`${API_URL}/syllabus/subtopic/${subTopicId}`);
};

// Delete entire Syllabus by ID
export const deleteSyllabusAPI = async (syllabusId) => {
  return axios.delete(`${API_URL}/syllabus/bulk-delete/${syllabusId}`);
};


// Create Department
export const createDepartment = (department) => {
  return axios.post(`${API_URL}/departments`, department);
};

// Get all departments (NOT by manager)
export const getAllDepartments = () => {
  return axios.get(`${API_URL}/departments`);
};

// Get departments by manager
export const getDepartmentsByManager = (managerId) => {
  return axios.get(`${API_URL}/departments/manager/${managerId}`);
};

// Delete department
export const deleteDepartment = (id) => {
  return axios.delete(`${API_URL}/departments/${id}`);
};

// ===== Trainee Department APIs =====
export const getTraineeDepartments = (traineeId) =>
  axios.get(`${API_URL}/trainee-departments/${traineeId}`);

export const assignDepartmentToTrainee = (traineeId, deptId) =>
  axios.post(`${API_URL}/trainees/${traineeId}/departments/${deptId}`);

export const removeDepartmentFromTrainee = (traineeId, deptId) =>
  axios.delete(`${API_URL}/trainees/${traineeId}/departments/${deptId}`);


export const updateDepartment = async (id, payload) => {
  try {
    const response = await axios.put(`${API_URL}/departments/${id}`, payload);
    return response.data;
  } catch (error) {
    throw new Error("Error updating department");
  }
  }

  
  export const fetchAllDepartments = async () => {
  try {
    const response = await axios.get(`${API_URL}/departments/departments`);
    return response.data;
  } catch (error) {
    console.error("Error fetching departments:", error);
    throw error;
  }
};
  
export const fetchAllRoles = () => {
  return axios.get(`${API_URL}/roles`);
};

// ================= TRAINEE CRUD =================
export const addTrainee = (data) => {
  return axios.post(`${API_URL}/users/addtrainees`, data);
};

export const updateTrainee = (trngid, data) => {
  return axios.put(`${API_URL}/users/addtrainee/${trngid}`, data);
};

export const deleteTraineeById = (trngid) => {
  return axios.delete(`${API_URL}/users/addtrainee/${trngid}`);
};

export const getTraineeById = (trngid) => {
  return axios.get(`${API_URL}/users/addtrainee/${trngid}`);
};

// ================= ASSIGN DEPARTMENT =================
export const updateTraineeDepartments = (traineeId, deptIds) => {
  return axios.put(
    `${API_URL}/trainee-departments/${traineeId}`,
    deptIds
  );
};

export const fetchCompletedSubTopicsByManager = async (managerId) => {
  try {
    const response = await axios.get(
      `${API_URL}/syllabus/syllabus-progress/${managerId}`
    );
    return response;
  } catch (error) {
    console.error("Error fetching syllabus progress:", error);
    throw error;
  }
};


// ================= TRAINING FEEDBACK APIs =================

// export const submitTraineeFeedback = async (syllabusId, userId, feedback) => {
//   const response = await fetch(
//     `${process.env.REACT_APP_API_URL}/training/trainee-feedback?syllabusId=${syllabusId}&userId=${userId}&feedback=${encodeURIComponent(feedback)}`,
//     {
//       method: "POST",
//     }
//   );

//   if (!response.ok) {
//     throw new Error("Failed to submit feedback");
//   }

//   return response.text();
// };

// export const submitTrainerRemark = async (syllabusId, userId, remark) => {
//   const response = await fetch(
//     `${process.env.REACT_APP_API_URL}/training/trainer-remark?syllabusId=${syllabusId}&userId=${userId}&remark=${encodeURIComponent(remark)}`,
//     {
//       method: "POST",
//     }
//   );

//   if (!response.ok) {
//     throw new Error("Failed to submit trainer remark");
//   }

//   return response.text();
// };

// export const submitManagerAssessment = async (syllabusId, userId, assessment) => {
//   const response = await fetch(
//     `${process.env.REACT_APP_API_URL}/training/manager-assessment?syllabusId=${syllabusId}&userId=${userId}&assessment=${encodeURIComponent(assessment)}`,
//     {
//       method: "POST",
//     }
//   );

//   if (!response.ok) {
//     throw new Error("Failed to submit manager assessment");
//   }

//   return response.text();
// };



export const fetchSyllabusByTrainer = async (trainerId) => {
  try {
    const response = await axios.get(`${API_URL}/syllabus/trainer/${trainerId}`);
    return response.data;
  } catch (error) {
    console.error(`Error fetching syllabus for trainer ${trainerId}:`, error);
    return [];
  }
};


// // ================= TRAINER SUBMIT =================
// export const submitTrainerFeedbackAPI = async (
//   trngid,
//   syllabusId,
//   feedback
// ) => {
//   try {
//     const response = await axios.post(
//       `${API_URL}/feedback/trainer`,
//       null,
//       {
//         params: {
//           trngid,
//           syllabusId,
//           feedback,
//         },
//       }
//     );

//     return response.data;
//   } catch (error) {
//     console.error("Trainer feedback submit error:", error);
//     throw error;
//   }
// };

// ================= TRAINEE SUBMIT =================
export const submitTraineeFeedbackAPI = async (
  traineeId,
  trainerId,
  syllabusId,
  feedback
) => {
  try {
    console.log("Trainee Submit:", traineeId, trainerId, syllabusId, feedback);

    const response = await axios.post(
      `${API_URL}/feedback/trainee`,
      null,
      {
        params: {
          traineeId,
          trainerId,
          syllabusId,
          feedback,
        },
      }
    );

    return response.data;
  } catch (error) {
    console.error("Trainee feedback submit error:", error.response?.data);
    console.error("Status:", error.response?.status);
    console.error("Full Error:", error);
    throw error;
  }
};

// ================= TRAINER SUBMIT =================
export const submitTrainerFeedbackAPI = async (
  traineeId,
  trainerId,
  syllabusId,
  feedback
) => {
  try {
    console.log("Trainer Submit:", traineeId, trainerId, syllabusId, feedback);

    const response = await axios.post(
      `${API_URL}/feedback/trainer`,
      null,
      {
        params: {
          traineeId,
          trainerId,
          syllabusId,
          feedback,
        },
      }
    );

    return response.data;
  } catch (error) {
    console.error("Trainer feedback submit error:", error.response?.data);
    console.error("Status:", error.response?.status);
    console.error("Full Error:", error);
    throw error;
  }
};


// ================= GET FEEDBACK =================
export const getSyllabusFeedbackAPI = async (
  traineeId,
  trainerId,
  syllabusId
) => {
  try {
    const response = await axios.get(
      `${API_URL}/feedback/data`,
      {
        params: {
          traineeId,
          trainerId,
          syllabusId,
        },
      }
    );

    return response.data;
  } catch (error) {
    console.error("Get feedback error:", error.response?.data);
    console.error("Status:", error.response?.status);
    throw error;
  }
};


export const fetchAssignedSyllabusWithFeedbackForAdmin = async (
  traineeId,
  managerId
) => {
  try {
    const response = await axios.get(`${API_URL}/feedback/assigned`, {
      params: {
        traineeId,
        managerId,
      },
    });

    return response.data;
  } catch (error) {
    console.error("Error fetching syllabus feedback:", error);
    throw error;
  }
};


export const fetchAssignedSyllabus = async (traineeId) => {
  try {
    const response = await axios.get(
      `${API_URL}/feedback/assigned-syllabus`,
      {
        params: { traineeId },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching assigned syllabus:", error);
    throw error;
  }
};

export const fetchFeedbackBySyllabusForManager = async (traineeId, syllabusId) => {
  const response = await axios.get(
    `${API_URL}/feedback/trainee-feedback-by-syllabus`,
    {
      params: {
        traineeId: traineeId,
        syllabusId: syllabusId
      }
    }
  );

  return response.data;
};



export const fetchAllDelays = () => axios.get(`${API_URL}/dashboard/delays`);
export const fetchTraineeDelays = (traineeId) =>
  axios.get(`${API_URL}/dashboard/delays/${traineeId}`);

export const fetchManagerDelays = (managerId) =>
  axios.get(`${API_URL}/dashboard/manager-delays/${managerId}`);
/* ===================== E-learning features ===================== */

// Feature B: tasks + performance score
export const recordTasksCompleted = (empid, subtopicId, tasksCompleted) =>
  axios.post(`${API_URL}/step-progress/tasks`, { empid, subtopicId, tasksCompleted });

export const getTaskScore = (empid) =>
  axios.get(`${API_URL}/step-progress/score/${empid}`);

// Feature C: training sessions, remarks, objections
export const markSessionConducted = (scheduleId, conducted = true) =>
  axios.put(`${API_URL}/sessions/conduct/${scheduleId}`, { conducted });

export const setParticipantRemark = (mapId, attended, remark) =>
  axios.put(`${API_URL}/sessions/remark/${mapId}`, { attended, remark });

export const getSessionParticipants = (scheduleId) =>
  axios.get(`${API_URL}/sessions/participants/${scheduleId}`);

export const raiseSessionObjection = (mapId, reason) =>
  axios.post(`${API_URL}/sessions/objection/${mapId}`, { reason });

export const resolveSessionObjection = (objectionId, status, resolutionRemark) =>
  axios.put(`${API_URL}/sessions/objection/resolve/${objectionId}`, { status, resolutionRemark });

export const listSessionObjections = (status) =>
  axios.get(`${API_URL}/sessions/objections`, { params: status ? { status } : {} });

export const getTraineeObjections = (trngid) =>
  axios.get(`${API_URL}/sessions/objections/trainee/${trngid}`);

// Task Management
export const createTask = (managerId, payload) =>
  axios.post(`${API_URL}/tasks/create/${managerId}`, payload);

export const getTasksByManager = (managerId) =>
  axios.get(`${API_URL}/tasks/manager/${managerId}`);

export const getTasksForTrainee = (traineeId) =>
  axios.get(`${API_URL}/tasks/trainee/${traineeId}`);

export const submitTask = (taskId, traineeId, payload) =>
  axios.post(`${API_URL}/tasks/${taskId}/submit/${traineeId}`, payload);

export const getTaskSubmissions = (taskId) =>
  axios.get(`${API_URL}/tasks/${taskId}/submissions`);

export const reviewSubmission = (submissionId, payload) =>
  axios.put(`${API_URL}/tasks/review/${submissionId}`, payload);

export const deleteTask = (taskId) =>
  axios.delete(`${API_URL}/tasks/${taskId}`);

// Quiz / Assessment Management
export const createQuiz = (managerId, payload) =>
  axios.post(`${API_URL}/quizzes/create/${managerId}`, payload);

export const getQuizzesByManager = (managerId) =>
  axios.get(`${API_URL}/quizzes/manager/${managerId}`);

export const getQuizzesForTrainee = (traineeId) =>
  axios.get(`${API_URL}/quizzes/trainee/${traineeId}`);

export const getQuizById = (quizId) =>
  axios.get(`${API_URL}/quizzes/${quizId}`);

export const submitQuiz = (quizId, traineeId, payload) =>
  axios.post(`${API_URL}/quizzes/${quizId}/submit/${traineeId}`, payload);

export const getQuizAttempts = (quizId) =>
  axios.get(`${API_URL}/quizzes/${quizId}/attempts`);

export const deleteQuiz = (quizId) =>
  axios.delete(`${API_URL}/quizzes/${quizId}`);

// Typing Speed Test
export const createTypingTest = (managerId, payload) =>
  axios.post(`${API_URL}/typing/create/${managerId}`, payload);

export const getTypingTestsByManager = (managerId) =>
  axios.get(`${API_URL}/typing/manager/${managerId}`);

export const getTypingTestsForTrainee = (traineeId) =>
  axios.get(`${API_URL}/typing/trainee/${traineeId}`);

export const getTypingTestById = (testId) =>
  axios.get(`${API_URL}/typing/${testId}`);

export const submitTypingTest = (testId, traineeId, payload) =>
  axios.post(`${API_URL}/typing/${testId}/submit/${traineeId}`, payload);

export const getTypingResults = (testId) =>
  axios.get(`${API_URL}/typing/${testId}/results`);

export const deleteTypingTest = (testId) =>
  axios.delete(`${API_URL}/typing/${testId}`);

// Video Lessons
export const createVideo = (managerId, payload) =>
  axios.post(`${API_URL}/videos/create/${managerId}`, payload);

export const getVideosByManager = (managerId) =>
  axios.get(`${API_URL}/videos/manager/${managerId}`);

export const getVideosForTrainee = (traineeId) =>
  axios.get(`${API_URL}/videos/trainee/${traineeId}`);

export const getVideoById = (videoId) =>
  axios.get(`${API_URL}/videos/${videoId}`);

export const updateVideoProgress = (videoId, traineeId, payload) =>
  axios.post(`${API_URL}/videos/${videoId}/progress/${traineeId}`, payload);

export const getVideoProgress = (videoId) =>
  axios.get(`${API_URL}/videos/${videoId}/progress`);

export const deleteVideo = (videoId) =>
  axios.delete(`${API_URL}/videos/${videoId}`);

// Batch Management
export const createBatch = (managerId, payload) =>
  axios.post(`${API_URL}/batches/create/${managerId}`, payload);

export const getBatchesByManager = (managerId) =>
  axios.get(`${API_URL}/batches/manager/${managerId}`);

export const getAllBatches = () =>
  axios.get(`${API_URL}/batches/all`);

export const getBatchById = (batchId) =>
  axios.get(`${API_URL}/batches/${batchId}`);

export const addTraineesToBatch = (batchId, payload) =>
  axios.put(`${API_URL}/batches/${batchId}/add-trainees`, payload);

export const removeTraineesFromBatch = (batchId, payload) =>
  axios.put(`${API_URL}/batches/${batchId}/remove-trainees`, payload);

export const deleteBatch = (batchId) =>
  axios.delete(`${API_URL}/batches/${batchId}`);

// Approved-device management (authorized by HRMS role via X-HRMS-AUTH interceptor)
export const getApprovedDevices = () =>
  axios.get(`${API_URL}/devices`);

export const addApprovedDevice = (payload) =>
  axios.post(`${API_URL}/devices`, payload);

export const toggleApprovedDevice = (id) =>
  axios.put(`${API_URL}/devices/${id}/toggle`);

export const deleteApprovedDevice = (id) =>
  axios.delete(`${API_URL}/devices/${id}`);
